var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPoolMobile = function SvgPoolMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 512 939"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolMobile_svg__a)",
    fillRule: "evenodd",
    d: "M511.896 94.556c0 8.978-63.42 16.692-154.098 20.053-3.076.23-7.052.602-4.242 1.506 5.72 1.217 8.868 2.546 8.868 3.938 0 5.841-55.466 10.577-123.886 10.577s-123.886-4.736-123.886-10.577c0-1.545 3.876-3.012 10.843-4.334a34 34 0 0 1 1.776-.417c6.189-1.322.335-1.747-3.211-2.005l-.465-.034C49.513 109.434 0 102.489 0 94.556c0-12.069 114.592-21.852 255.948-21.852s255.948 9.783 255.948 21.852",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolMobile_svg__b)",
    d: "M145.05 127.393h8.753v807.234a4.377 4.377 0 1 1-8.753 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolMobile_svg__c)",
    fillRule: "evenodd",
    d: "M261.939 126.242c41.266-.299 73.823-3.777 73.823-8.024 0-.798-1.148-1.568-3.286-2.295 9.474 1.073 15.058 2.391 15.058 3.817 0 3.601-35.642 6.52-79.608 6.52q-3.021 0-5.987-.018",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolMobile_svg__d)",
    fillRule: "evenodd",
    d: "M209.343 126.242c-41.266-.299-73.823-3.777-73.823-8.024 0-.798 1.148-1.568 3.287-2.295-9.474 1.073-15.058 2.391-15.058 3.817 0 3.601 35.641 6.52 79.607 6.52q3.022 0 5.987-.018",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolMobile_svg__e)",
    fillRule: "evenodd",
    d: "M263.735 106.258c40.302 0 72.974-4.462 72.974-9.967 0-5.504-32.672-9.967-72.974-9.967s-72.974 4.463-72.974 9.967 32.672 9.967 72.974 9.967m-.001-1.736c35.395 0 64.087-4.074 64.087-9.099s-28.692-9.099-64.087-9.099c-35.394 0-64.087 4.074-64.087 9.099s28.693 9.099 64.087 9.099",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolMobile_svg__f)",
    fillRule: "evenodd",
    d: "M263.732 111.015c59.532 0 107.792-6.591 107.792-14.722s-48.248-14.721-107.77-14.723m-.022 29.445c-59.531 0-107.791-6.591-107.791-14.722ZM155.941 96.293c0-8.131 48.26-14.723 107.791-14.723ZM263.732 81.57zm.001 26.88c52.282 0 94.664-6.017 94.664-13.44s-42.371-13.438-94.643-13.44m-.021 26.88c-52.281 0-94.664-6.017-94.664-13.44Zm-94.664-13.44c0-7.423 42.383-13.44 94.664-13.44Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolMobile_svg__g)",
    fillRule: "evenodd",
    d: "M154.241 107.343c-35.5-3.253-56.994-7.502-56.994-12.151 0-8.724 75.674-16.039 177.558-18.002-119.059.727-212.553 7.95-212.553 16.753 0 5.47 36.094 10.329 91.989 13.4",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolMobile_svg__h)",
    fillRule: "evenodd",
    d: "M392.902 100.69c29.837-2.83 47.894-6.525 47.894-10.566 0-3.895-16.778-7.468-44.713-10.256 37.154 2.608 60.242 6.26 60.242 10.302 0 4.155-24.411 7.899-63.423 10.52",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolMobile_svg__i)",
    fillRule: "evenodd",
    d: "M452.836 103.647c15.648-2.894 24.468-6.169 24.468-9.637 0-3.727-10.187-7.23-28.088-10.278 29.47 2.818 46.951 6.329 46.951 10.135 0 3.648-16.055 7.025-43.331 9.78",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolMobile_svg__j)",
    d: "M113.235 143.461a3 3 0 1 0 6 0zm6 9.16a3 3 0 1 0-6 0zm-6 3.577a3 3 0 1 0 6 0zm0-36.209v23.472h6v-23.472zm0 32.632v3.577h6v-3.577z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolMobile_svg__k)",
    d: "M362.424 161.278v-41.28l-25.658 5.898v109.156c0 7.795 9.555 6.755 9.555 0v-55.568c13.013.358 16.157-11.988 16.103-18.206"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolMobile_svg__l)",
    fillRule: "evenodd",
    d: "M280.631 94.653a73.1 73.1 0 0 1-32.549-.525 18.2 18.2 0 0 1-2.082-8.44c0-7.523 3.515-13.16 7.797-20.03 3.331-5.343 7.127-11.431 10.094-19.73.173-.485.606-1.928.606-1.928l.003.01.003-.01s.433 1.443.606 1.928c2.967 8.299 6.763 14.387 10.094 19.73v.001C279.485 72.528 283 78.166 283 85.687c0 3.168-.829 6.251-2.369 8.966",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#poolMobile_svg__m)",
    d: "M222.259 33.669a10.25 10.25 0 0 1-7.254-3.01A10.29 10.29 0 0 1 212 23.393c0-4.221 1.949-7.385 4.324-11.24 1.847-2.998 3.951-6.414 5.597-11.07.096-.273.336-1.083.336-1.083l.002.005.001-.005s.24.81.336 1.082c1.646 4.657 3.75 8.073 5.597 11.071 2.375 3.855 4.324 7.019 4.324 11.24 0 2.725-1.081 5.339-3.005 7.266a10.32 10.32 0 0 1-7.253 3.01"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolMobile_svg__a",
    x1: 112.114,
    x2: 369.895,
    y1: 110.485,
    y2: 120.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3A5D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0E2EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolMobile_svg__b",
    x1: 149.426,
    x2: 149.426,
    y1: 131.07,
    y2: 939.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAAEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B1E3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9FCFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#99AEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A293FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C389F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E98EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F992D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolMobile_svg__c",
    x1: 261.939,
    x2: 347.534,
    y1: 121.092,
    y2: 121.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99D3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolMobile_svg__d",
    x1: 291.132,
    x2: 49.26,
    y1: 115.923,
    y2: 109.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFFFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6CDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolMobile_svg__e",
    x1: 224.392,
    x2: 248.624,
    y1: 125.773,
    y2: 77.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBEE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolMobile_svg__f",
    x1: 354.284,
    x2: 181.44,
    y1: 107.586,
    y2: 81.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolMobile_svg__g",
    x1: 80.341,
    x2: 187.257,
    y1: 88.53,
    y2: 89.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A594FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolMobile_svg__h",
    x1: 392.902,
    x2: 443.966,
    y1: 90.279,
    y2: 96.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADCDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolMobile_svg__i",
    x1: 472.691,
    x2: 472.691,
    y1: 83.732,
    y2: 103.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2E7D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFE4EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolMobile_svg__j",
    x1: 116.735,
    x2: 116.735,
    y1: 120.126,
    y2: 353.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3A6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B1E3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9FCFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#99AEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A293FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C389F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E98EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F992D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolMobile_svg__k",
    x1: 349.595,
    x2: 349.595,
    y1: 119.998,
    y2: 253.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7DCE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DBFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolMobile_svg__l",
    x1: 419.086,
    x2: 419.086,
    y1: -320.8,
    y2: 101.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#9FCFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#99AEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#A293FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#C389F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#E98EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F992D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FFA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#FFE0A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poolMobile_svg__m",
    x1: 222.259,
    x2: 222.259,
    y1: -75.471,
    y2: 189.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#9FCFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#99AEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#A293FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#C389F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#E98EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F992D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FFA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#FFE0A3"
  })))));
};
export default SvgPoolMobile;